import { SiteHeading } from "../components/SiteHeading/SiteHeading";

export const TutorialsPage = () => {
  return (
    <>
      <SiteHeading title='Tutorials' />
      <p style={{ marginTop: "20px" }}>There seems to be nothing here...</p>
      <p>
        Visit <a href='https://github.com/Rllyyy/repeatio'>Github</a> to view the current status of this project.
      </p>
    </>
  );
};
